import React from "react";
import moment from "moment";
import FormattedCurrencyNumberCustom from "../formatted-currency-number-custom";
import { useRecordContext } from "react-admin";
import { getLocalStorageKey } from "../common/common";

export const ExpectedDateField = ({ record = {}, source }) => {
  return (
    <span>
      {`${moment(record[source]).format("MM/DD/YYYY")} - ${moment(
        record[source]
      )
        .add(2, "days")
        .format("MM/DD/YYYY")}`}
    </span>
  );
};

export const OrderStatus = ({ source,  order_status}) => {
  const record = useRecordContext();
  const localStorageLocale = getLocalStorageKey("locale");

  // const color = {
  //   Pending: "#b60205",
  //   Accepted: "#0E8A16",
  //   Canceled: "#776e6e",
  //   Dispatched: "#fbca04",
  //   Delivered: "#049CF1",
  //   Cancelled: "#776e6e",
  //   Deleted: "#776e6e",
  // };

  const statusBackColorCheck = () => {
    switch (record[order_status]) {
      case '0':
        return { backgroundColor: '#0C1638', color: '#F5F5F5'};
      case '1':
      case 'A':
      case '9':
      case '10':
        return { backgroundColor: '#0E8A16', color: '#0C1638'};
      case '2':
      case 'B':
      case '8':
      case '13':
        return { backgroundColor: '#103776', color: '#F5F5F5'};
      case '3':
      case 'C':
      case '5':
        return { backgroundColor: '#01FBFF', color: '#0C1638'};
      case '4':
      case 'D':
      case '15':
      case '17':
        return { backgroundColor: '#FF4874', color: '#F5F5F5'};
      case '7':
      case '14':
        return { backgroundColor: '#9F9F9F', color: '#F5F5F5'};
      case '11':
        return { backgroundColor: '#EB6400', color: '#F5F5F5'};
      case '16':
        return { backgroundColor: '#EFBD00', color: '#F5F5F5'};
      default:
        return { backgroundColor: '#01FBFF', color: '#0C1638'};
    }
  }

  return (
    <span
      style={{
        backgroundColor: statusBackColorCheck()?.backgroundColor,
        padding: "5px 10px",
        borderRadius: "15px",
        color: localStorageLocale === "en-GB" ? "#ffffff" : "#000000",
      }}
    >
        {record[source]}
    </span>
  );
};

export const AmountField = ({ record = {}, source }) =>
  record[source] ? (
    <span>
      {record["currency"]} {record[source]}
    </span>
  ) : (
    "-"
  );

export const LineItemTotalField = ({ record = {}, source }) =>
  record["unit_price"] ? (
    <span>
      {record.currency}{" "}
      <FormattedCurrencyNumberCustom
        value={(record["unit_price"] * record["quantity"]).toFixed(2)}
      />
    </span>
  ) : (
    "-"
  );

export const PaymentAmountField = ({ record = {}, source }) =>
  record["payment_amount"] ? (
    <span>
      {record.currency}{" "}
      <FormattedCurrencyNumberCustom
        value={record["payment_amount"].toFixed(2)}
      />
    </span>
  ) : (
    "-"
  );

export const MaterialQtyUom = ({ record = {}, source }) =>
  record["quantity"] ? (
    <span>
      {" "}
      {record["quantity"]}{" "}
      {record["ordered_uom"] === "TON" || record["ordered_uom"] === "TN"
        ? "T"
        : record["ordered_uom"]}{" "}
    </span>
  ) : (
    "-"
  );
export const ConvQtyField = ({ record = {}, source }) =>
  record.product_master && record.product_master.show_conversion ? (
    <span>
      {(record.product_master.conversion_factor * record[source]).toFixed(2)}
    </span>
  ) : null;

export const ConvQtyUomField = ({ record = {}, source }) =>
  record.product_master && record.product_master.show_conversion ? (
    <span>{record.product_master.conversion_uom_name}</span>
  ) : null;

export const CamelCaseField = ({ source }) => {
  const record = useRecordContext();
  let camelCased =
    record[source] &&
    record[source].replace(/_([a-z])/g, (g) => ` ${g[1].toUpperCase()}`);
  camelCased = camelCased.charAt(0).toUpperCase() + camelCased.slice(1);
  return camelCased ? <span>{camelCased}</span> : "-";
};
